import { container } from "tsyringe";
import { HandoverV2Endpoints } from "../../endpoints/hydra/HandoverV2Endpoints";
import { HandoverV2Presenter } from "@/app/ui/presenters/HandoverV2Presenter";
import { HandoverV2ApiRepository } from "../../repositories/api/HandoverV2ApiRepository";
import { HandoverV2Mapper } from "@/data/persistences/mappers/HandoverV2Mapper";
import ApiService from "../../services/ApiService";

export class HandoverV2Component {
  public static init() {
    container.register<HandoverV2Endpoints>(HandoverV2Endpoints, {
      useClass: HandoverV2Endpoints
    });
    container.register<HandoverV2Mapper>(HandoverV2Mapper, {
      useClass: HandoverV2Mapper
    });
    container.register<HandoverV2ApiRepository>(HandoverV2ApiRepository, {
      useFactory: (d) =>
        new HandoverV2ApiRepository(
          d.resolve(ApiService),
          d.resolve(HandoverV2Mapper),
          d.resolve(HandoverV2Endpoints)
        )
    });
    container.register<HandoverV2Presenter>(HandoverV2Presenter, {
      useFactory: (d) =>
        new HandoverV2Presenter(d.resolve(HandoverV2ApiRepository))
    });
  }
}
